import { Dispatch, SetStateAction, useEffect } from 'react'
import { StockType } from 'types/stock'
import { getRandomID } from 'lib/helper'
import { addDefaultStock } from 'lib/stock'
import { BreadType } from 'types/bread'
import { ScheduleType } from 'types/schedule'
import { FirebaseDocRefType } from 'firebase'
import { DayOfWeekType } from 'lib/daysOfWeek'

const useSetInitialStocks = (
  bread: BreadType | undefined,
  schedules: ScheduleType[],
  storeRef: FirebaseDocRefType,
  storeName: string,
  stocks: StockType[],
  setStockList: Dispatch<SetStateAction<StockType[]>>,
  date: string,
  dayOfWeek: DayOfWeekType,
  latestOrderStartTime: string,
  latestOpenTime: string,
  earliestLastOrderTime: string,
  isAfterLastOrder: boolean,
  isClosed: boolean
) => {
  return useEffect(() => {
    if (!bread || !storeRef || !storeName) return

    if (stocks.length > 0) {
      setStockList([...stocks])
    } else {
      const _stocks: StockType[] = []

      // stocksが存在しない場合schedulesから初期stockを作成する
      const schedule = schedules.find((schedule) => schedule.days_of_week.includes(dayOfWeek))
      if (!schedule) {
        const defaultSchedule = schedules[0]
        if (!defaultSchedule) return
        const pickupableTime = latestOpenTime
        const stockRef = storeRef.collection('store_stocks').doc(getRandomID())
        _stocks.push(
          addDefaultStock(
            bread,
            storeRef,
            defaultSchedule,
            stockRef,
            latestOrderStartTime,
            earliestLastOrderTime,
            storeName,
            date,
            pickupableTime
          )
        )
      } else {
        for (let i = 0; i < schedule.default_stocks.length; i = (i + 1) | 0) {
          const defaultStock = schedule.default_stocks[i]
          const pickupableTime = defaultStock.pickupable_time
          const stockRef = storeRef
            .collection('store_stocks')
            .doc(`stock_daily_${schedule.schedule_ref?.id}-${date}_${pickupableTime}`)
          _stocks.push(
            addDefaultStock(
              bread,
              storeRef,
              schedule,
              stockRef,
              latestOrderStartTime,
              earliestLastOrderTime,
              storeName,
              date,
              pickupableTime,
              defaultStock.stock
            )
          )
        }
      }
      setStockList([..._stocks])
    }
  }, [
    bread,
    schedules,
    storeRef,
    storeName,
    stocks,
    setStockList,
    date,
    dayOfWeek,
    latestOrderStartTime,
    latestOpenTime,
    earliestLastOrderTime,
    isAfterLastOrder,
    isClosed,
  ])
}

export default useSetInitialStocks
